export default {
  createDialog({ commit }, payload) {
    commit('DIALOG_CREATE', payload);
  },
  destroyDialog({ commit }, payload) {
    commit('DIALOG_DESTROY', payload);
  },
  openDialog({ commit, getters }, payload) {
    const dialog = { ...getters.dialogById(payload) };
    commit('DIALOG_UPDATE', { ...dialog, visible: true });
  },
  closeDialog({ commit, getters }, payload) {
    let dialog;
    if (payload) {
      dialog = getters.dialogById(payload);
    } else {
      dialog = getters.openedDialog;
    }
    commit('DIALOG_UPDATE', { ...dialog, visible: false });
  },
}
